import { forwardRef } from "react";
import PropTypes from "prop-types";
import { useStateMachine } from "little-state-machine";
import { updateAction } from "../updateAction";
import { useVariants } from "../hooks/useVariants";
import { useCurrencyState } from "@hooks/useCurrency";
import { Spinner } from "@components/Spinner";
import { Carousel } from "../Carousel";
import { MobileForm } from "./MobileForm";
import { resolveBundleDiscount } from "../lib/resolve-bundle-discount";
import formatVariantPrice from "../../lib/format-variant-price";
import styles from "./styles/MobileSection.module.css";

export const MobileSection = forwardRef(
  ({ section, index, handleScrollTo, sections, isStockup, discountMessage, slug }, ref) => {
    const { currency } = useCurrencyState();
    const { isError, error, isLoading, images } = useVariants(section);
    const { actions, state } = useStateMachine({ updateAction });

    const changeProduct = (productGroup) => {
      const updatedState = {};
      updatedState[`${section.key}-productGroup`] = productGroup;
      updatedState[`${section.key}-product`] = productGroup.shopifyProducts[0];
      updatedState[`${section.key}-variant`] =
        productGroup.shopifyProducts[0].productReferenceV2.variants[0];
      actions.updateAction(updatedState);
    };

    if (isLoading) {
      return (
        <section className={styles.loading}>
          <Spinner />
        </section>
      );
    }

    if (isError) {
      return <section className={styles.loading}>Something went wrong {error}</section>;
    }

    let price = "NAN";
    let compareAtPrice = "NAN";
    if (state[`${section.key}-variant`]) {
      const result = formatVariantPrice(state[`${section.key}-variant`], currency);
      price = result.price;
      compareAtPrice = result.compareAtPrice;
      const amount = result.amount;

      if (discountMessage) {
        const discount = discountMessage.match(/\d+(\%)/g);
        if (discount) {
          if (!compareAtPrice) {
            compareAtPrice = price;
          }
          price = resolveBundleDiscount(amount, parseFloat(discount[0]) / 100.0, currency);
        }
      }
    }

    return (
      <div className={styles.section} ref={ref}>
        {state[`${section.key}-productGroup`] && (
          <>
            <header className={styles.header}>
              <h2>
                <span className={styles.headerLight}>{section.sectionTitle} </span>
                {state[`${section.key}-productGroup`].title.replace(/(Wo)?[Mm]en['’]?s /g, "")}
              </h2>
              <section className={styles.priceContainer}>
                <span className={styles.price}>{price}</span>
                {compareAtPrice && (
                  <span className={styles.compareAtPrice}>
                    {compareAtPrice.replace(/[CA]/g, "")}
                  </span>
                )}
              </section>
            </header>

            <Carousel
              images={images}
              changeProduct={changeProduct}
              isMobile
              currentProductGroupID={state[`${section.key}-productGroup`]._id}
            />
            <MobileForm
              section={section}
              sections={sections}
              index={index}
              handleScrollTo={handleScrollTo}
              discountMessage={discountMessage}
              isStockup={isStockup}
              slug={slug}
            />
          </>
        )}
      </div>
    );
  }
);

MobileSection.propTypes = {};
